<template>
  <footer class="footer">
    <div class="container-fluid">
      <!--<nav class="pull-left">
        <ul>
          <li>
            <a href="">
              Page Name
            </a>
          </li>
        </ul>
      </nav>
      <div class="copyright pull-right">
        &copy; Desarrollado con
        <i class="fa fa-heart heart"></i> por
        <a href="https://namtrik.dev" target="_blank" rel="noopener">Namtrik Development</a>.
      </div>-->
      <div class="copyright pull-right">
        <span style="color: black;">&copy; Banco Mundo Mujer S.A. - EMI - Módulo administrativo v2.0.0RC005</span>
      </div>
    </div>
  </footer>
</template>
<script>
  export default {}

</script>
<style>

</style>
